import React, { useRef, useState, useEffect } from "react";
import {
    TableContainer,
    FormH1,
    ListRow,
    RowInfoStack,
    ToolTipPointer,
    ToolTipContainer,
    ToolTipTopLine,
    ToolTipP,
    ToolTipFooter,
    ColWrapper,
    ListRowPort,
    RowIcon,
    RowH1,
    RowH2,
} from "./LayTraderTableElements";

import ReactDOM from 'react-dom';

function LTTable({ id, watchlist, holdings, data, setCurrentStock, setWatchlistStock, handleRemoveFromWL, demoState, demo }) {
    const watchlistRef = useRef();
    const portfolioRef = useRef();

    const { sortedObjA: aWatchlist, sortedArrB: aHoldings } = (() => {
        const mapB = new Map(holdings.map(item => [item.ticker, item]));
        const keysA = Object.keys(watchlist);
        const sharedKeys = keysA
            .filter(key => mapB.has(key))
            .sort((a, b) => a.localeCompare(b));

        const uniqueKeysA = keysA
            .filter(key => !mapB.has(key))
            .sort((a, b) => a.localeCompare(b));

        const uniqueItemsB = holdings.filter(item => item.ticker != "CASH")
            .filter(item => !watchlist.hasOwnProperty(item.ticker))
            .sort((a, b) => a.ticker.localeCompare(b.ticker));
        const sortedObjA = {};
        sharedKeys.forEach(key => { sortedObjA[key] = watchlist[key]; });
        uniqueKeysA.forEach(key => { sortedObjA[key] = watchlist[key]; });
        const sortedArrB = [
            ...sharedKeys.map(key => mapB.get(key)),
            ...uniqueItemsB,
            ...holdings.filter(item => item.ticker === "CASH")
        ];

        return { sortedObjA, sortedArrB };
    })();


    const Tooltip = ({ targetRef, tipTitle = "", message, addTop = 0, addRight = 0, addRightMobile = 0, rightTM = 0, topTM = 0 }) => {
        const [coords, setCoords] = useState({ top: 0, left: 0 });

        useEffect(() => {
            if (targetRef.current) {
                const rect = targetRef.current.getBoundingClientRect();
                setCoords({ top: rect.top + window.scrollY + addTop, right: window.innerWidth - rect.right + addRight });
            }
        }, [targetRef]);
        const top = `${coords.top + addTop}px`
        const right = `${coords.right + addRight}px`

        const triangleTop = coords.top;
        const triangleRight = coords.right + 90;
        const topT = `${triangleTop}px`
        const rightT = `${triangleRight}px`

        const rightMobile = `${coords.right - addRightMobile}px`
        const topTMobile = `${triangleTop - topTM}px`
        const rightTMobile = `${triangleRight - rightTM}px`
        return ReactDOM.createPortal(
            <><ToolTipContainer top={top} right={right} rightMobile={rightMobile}>
                <ToolTipTopLine>{tipTitle}</ToolTipTopLine>
                <ToolTipP>{message}</ToolTipP>
                <ToolTipFooter>{`${demoState}/9`}</ToolTipFooter>
            </ToolTipContainer>

                <ToolTipPointer top={topT} right={rightT} topM={topTMobile} rightM={rightTMobile} />
            </>,
            document.body
        );
    };

    return (
        <TableContainer>
            <ColWrapper style={{ marginRight: "6px" }}>
                <FormH1 ref={watchlistRef}>Trade List</FormH1>
                {Object.keys(aWatchlist).map((item, index) => (
                    <ListRow
                        key={index}
                        onClick={() => setWatchlistStock({ id: id, currentStock: item })}
                        onContextMenu={(e) => {
                            handleRemoveFromWL(e, id, item);
                        }}
                        style={{ cursor: 'pointer', color: "fff" }}
                    >
                        <RowIcon>{item}</RowIcon>
                        <RowInfoStack style={{ marginLeft: "12px" }}>
                            <RowH2 style={{ justifyContent: "left", color: "white" }}>{data[item].title}</RowH2>
                            <RowH1 style={{ color: "white", fontSize: "10px" }}>close: ${data?.[item]?.close?.["D"].toFixed(2)}</RowH1>
                        </RowInfoStack>
                    </ListRow>
                ))}
            </ColWrapper>
            {demo && demoState === 4 && <Tooltip targetRef={watchlistRef} addTop={-10} addRight={-110} addRightMobile={-15} rightTM={5} tipTitle={"Current Trade List"} message={"View stock details (left click) and remove stocks from trade consideration (right click)"} />}
            <ColWrapper>
                <FormH1 ref={portfolioRef} >Portfolio</FormH1>
                {aHoldings.map((item, index) => (
                    <ListRowPort
                        key={index}
                        onClick={() => setCurrentStock({ id: id, currentStock: item })}
                        style={{ cursor: 'pointer', color: "fff" }}
                    >
                        <RowInfoStack style={{ justifyContent: "right", minWidth: "100px", marginRight: "12px" }}>
                            <RowH2 style={{ justifyContent: "flex-end", textAlign: "right", color: item.ticker === "CASH" ? "#cc8f2d" : "white" }}>{item.ticker == "CASH" ? "Cash" : data[item.ticker]?.title}</RowH2>
                            <RowH1 style={{ alignSelf: "end", color: "white", fontSize: "10px" }}>{item.ticker == "CASH"
                                ? `value : $${item.shares?.toFixed(2)}`
                                : `cost: $${item.cost.toFixed(2)}`}
                            </RowH1>
                        </RowInfoStack>
                        <RowIcon>{item.ticker}</RowIcon>
                    </ListRowPort>
                ))}
                {demo && demoState === 5 && <Tooltip targetRef={portfolioRef} addTop={-10} addRight={-110} addRightMobile={-25} rightTM={-5} tipTitle={"Current Positions"} message={"Get more information on the stocks in your current portfolio"} />}
            </ColWrapper>
        </TableContainer >
    );
};

export default LTTable;